import { timestamp, uuid } from "drizzle-orm/pg-core";

export const baseTableProps = {
	id: uuid("id").primaryKey().defaultRandom(),
	createdAt: timestamp("created_at", { withTimezone: true, mode: "string" })
		.defaultNow()
		.notNull(),
	updatedAt: timestamp("updated_at", { mode: "string", precision: 3 })
		.$onUpdate(() => new Date().toISOString())
		.defaultNow()
		.notNull()
};
